<template>
  废弃
</template>

<script>
import componentMixin from './componentMixin';

export default {
  name: "specialC",
  mixins: [componentMixin],
  computed: {
    imgSrc() {
      const image = this.$dt(this.eleConfig, 'image') || this.eleConfig.image;
      return image ? this.$Dolphin.path.publicPath + image.filePath : '';
    },
  }
};
</script>

<style scoped lang="scss">
</style>
